module.exports = __webpack_public_path__ + "img/time-red.67915b03.svg";